const CHANGE_AGILETV = 'OVID/CHANGE_AGILETV/CHANGE_AGILETV'
const CHANGE_AGILETV_SUCCESS = 'OVID/CHANGE_AGILETV/CHANGE_AGILETV_SUCCESS'
const CHANGE_AGILETV_FAILED = 'OVID/CHANGE_AGILETV/CHANGE_AGILETV_FAILED'

export const constants = {
  CHANGE_AGILETV,
  CHANGE_AGILETV_SUCCESS,
  CHANGE_AGILETV_FAILED,
}
